import _classCallCheck from "/Users/dstein/dev/jaxcore/cybertyper/examples/palefire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/dstein/dev/jaxcore/cybertyper/examples/palefire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/dstein/dev/jaxcore/cybertyper/examples/palefire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/dstein/dev/jaxcore/cybertyper/examples/palefire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/dstein/dev/jaxcore/cybertyper/examples/palefire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import EventEmitter from "events";

var SpeakerQueue =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(SpeakerQueue, _EventEmitter);

  function SpeakerQueue(speak) {
    var _this;

    _classCallCheck(this, SpeakerQueue);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SpeakerQueue).call(this));
    _this._queue = [];
    _this.speaker = speak;
    return _this;
  }

  _createClass(SpeakerQueue, [{
    key: "clearQueue",
    value: function clearQueue() {
      this._queue = [];
    }
  }, {
    key: "queue",
    value: function queue(speech) {
      this._queue.push(speech);

      this._speakNext();
    }
  }, {
    key: "_speakNext",
    value: function _speakNext() {
      var _this2 = this;

      if (this.isSpeaking) {
        return;
      }

      var next = this._queue.shift();

      if (next) {
        this.isSpeaking = true;
        this.speaker.getWorkerAudioData(next.text, next.options, function (audioContext, source) {
          if (next.onStart) {
            next.onStart(next);
          }

          next.scope.loadAudioData(audioContext, source, function () {
            if (next.onStop) {
              setTimeout(function () {
                next.onStop(next);
              }, 1);
            }

            _this2._onEnded();
          });
        });
      } else {
        this.emit('finish');
      }
    }
  }, {
    key: "_onEnded",
    value: function _onEnded() {
      this.isSpeaking = false;

      this._speakNext();
    }
  }]);

  return SpeakerQueue;
}(EventEmitter);

export default SpeakerQueue;